module.exports = __webpack_public_path__ + "img/whiteDownArrow.94595586.svg";